export default __webpack_public_path__ + "a8d8489df4a519c939700c606a25a982.woff2";